import React, { useState, useContext, useEffect } from 'react';
import { JobsType } from '../../constents/jobIndustries';
import { InputBoxWraper } from '../../constents/components';
import crossIcon from '../../Assets/svgs/closeIcon.svg';
import { useSelector } from 'react-redux';
import { MAX_INTREST_LIMIT_OF_PROFILE } from '../../constents/numbers';



const IntrestEdit = ({ values = [], updateJobIndustry = () => { }, updateIntrest = () => { } }) => {

    const industries = useSelector(store => store?.industries);
    const departments = Object.keys(industries);

    const [department, setDepartment] = useState(departments?.[0]);


    const onIntrestChange = (intrest) => {
        if (!values.includes(intrest) && values.length <= MAX_INTREST_LIMIT_OF_PROFILE) {
            const list = [intrest, ...values];
            updateIntrest(list);
            updateJobIndustry(department);
        }
    }
    const valueRemover = (intrest) => {
        if (values.includes(intrest)) {
            const list = values?.filter(item => item !== intrest);
            updateIntrest(list);
        }
    }

    const onDepartmentChange = (value) => {
        updateIntrest([]);
        setDepartment(value)
        updateJobIndustry(value);
    }
    return (
        <div className=' w-full'>
            {/* <p className=' text-sm pb-1'>Select your industry</p> */}
            <InputBoxWraper classnames={'w-full'}>
                <select
                    onChange={(e) => onDepartmentChange(e.target.value)}
                    className=' w-full bg-transparent outline-none border-none accent-primary_600'
                >
                    {departments.map((item, index) => (
                        <option
                            key={index}
                            value={item}
                        // className='hover:bg-primary_800'
                        >
                            {item}
                        </option>))
                    }
                </select>
            </InputBoxWraper>
            {department && (<>
                <h6 className='mt-6 text-sm pb-1'>Select job title</h6>
                <InputBoxWraper classnames={'w-full'}>
                    <select className='w-full bg-transparent outline-none border-none'
                        onChange={(e) => onIntrestChange(e.target.value)}
                    >
                        {industries?.[department]?.map((item, index) => (
                            <option
                                key={index}
                                value={item}
                            >
                                {item}
                            </option>))
                        }
                    </select>
                </InputBoxWraper>
            </>)}
            <div className='flex flex-wrap gap-4 mt-4'>{values?.map((item, index) => (
                <div
                    className={'p-2 px-4 bg-pills-bg-color-900 rounded-md flex gap-2 items-center justify-center'}
                    key={index}
                >
                    <span>{item}</span>
                    <img className=' w-4' onClick={() => valueRemover(item)} src={crossIcon} alt="crossIcon" />
                </div>))}
            </div>

        </div>
    )
}

export default IntrestEdit;